import get from "lodash/get"

export const selectPlanEventsList = state => get(state, `plan.planEvents`)
